<template>

  <div>

    <form>
      <ul class="item-detail item-detail-simple">
        <li>
          <div class="row">
            <div class="col-xs-12 col-md-9 spacer-t-2">
              <div class="form-group" :class="{ 'has-error' : $v.text.$error }" style="margin:0">
                <div id="notes-redactor-editor">
                  <redactor class="form-control" v-model="text" type="text"  name="note_text" placeholder="Enter note text here" rows="3"/>
                </div>

                <span class="help-block" v-if="$v.text.$error">Text is required</span>
              </div>
            </div>
            <div class="col-xs-12 col-md-3 spacer-t-2">
              <ladda-button class="btn btn-primary btn-block pull-right" type="submit" :click="handleAddNote">
                Add Note
              </ladda-button>
            </div>
          </div>
        </li>
      </ul>
    </form>

    <notes-list-item v-for="note in firstFiveNotes" :note="note" :key="note.id" @delete="handleDelete( note )" @pin="(id) => handlePin(id)"/>

    <div v-if="viewingAll" >
      <notes-list-item v-for="note in theRestOfTheNotes" :note="note" :key="note.id" @delete="handleDelete( note )" @pin="(id) => handlePin(id)"/>
    </div>

    <div class="row">
      <div class="col-xs-3 col-xs-push-9" v-if="isMoreNotesToView">
        <button class="btn btn-primary btn-block pull-right" type="button" data-toggle="collapse" data-target="#viewAll" aria-expanded="false" aria-controls="viewAll" @click="toggleViewingAll">
          {{ viewingAll ? 'View Less' : 'View All'}}
        </button>
      </div>
    </div>

  </div>

</template>

<script>
import { mapState } from 'vuex'
import {slice, cloneDeep} from 'lodash'
import Redactor from 'codium-redactor'
import NotesListItem from './NotesListItem'
import { OpportunityTracker } from 'mixins/analytics'

import {required} from 'vuelidate/lib/validators'
import {notify} from 'utils'

export default {
  mixins: [OpportunityTracker],
  props: {
    notes: {
      type: Array,
      required: true
    }
  },

  components: {
    Redactor,
    NotesListItem
  },

  data () {
    return {
      text: null,
      viewingAll: false
    }
  },

  validations: {
    text: { required }
  },

  computed: {
    ...mapState('booking', ['booking']),

    firstFiveNotes () {
      return slice(this.orderedNotes, 0, 5)
    },

    theRestOfTheNotes () {
      return slice(this.orderedNotes, 5)
    },

    isMoreNotesToView () {
      return this.theRestOfTheNotes.length > 0
    },

    orderedNotes () {
      let sortedNotes = cloneDeep(this.notes)
      return sortedNotes.sort(function (a, b) {
        return a.pinned === true ? -1 : 1
      })
    }

  },

  methods: {

    async handleAddNote () {
      if (this.$v.$invalid) {
        this.$v.$touch()
        return Promise.reject(new Error('Data invalid'))
      }

      try {
        await this.$listeners.addNote(this.text)
        this.trackEvent(this.analytics.V2.JobAdminNoteAddEvent)
        this.text = null
        this.$v.$reset()
      } catch (e) {
        notify.error('Error adding note. Please try again.')
      }
    },

    handleDelete (note) {
      this.$emit('deleteNote', note)
    },

    handlePin (note) {
      this.$emit('pin', note)
    },

    toggleViewingAll () {
      this.viewingAll = !this.viewingAll
    }

  }

}

</script>

<style lang="scss">
#notes-redactor-editor {
  .redactor-editor {
    min-height: 150px !important;
  }
  p {
    overflow: auto;
    white-space: inherit;
    text-overflow: inherit;
  }
}
</style>
